import { Icon, Text } from "@aidron/aidron-ds";
import { Link } from "react-router-dom";

import { textFormatter } from "../../../utils/formatter/formatter";

import PropTypes from 'prop-types';

import { CustomHeading, CustomText } from "../../StyledComponents/styleComponents.index";

export function LabelAndNumberView({ ctx }) {

  const { heading, number, text, numberText, link } = ctx || {};

  return (
    <div style={{ display: "flex", flexDirection: 'column', padding: '0.3rem', alignItems: "center" }}>
      <CustomText maxInlineSize={"100%"} inlineSize="100%" weight="bold" color="mediumGrey" fontSize={['0.3rem', '0.6rem', '1.1rem']}>
        {textFormatter(heading, { textTransform: 'uppercase' })}
      </CustomText>

      {/\d/.test(number) ? (
        <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", alignItems: "center" }}>
          <CustomHeading maxInlineSize={"100%"} inlineSize="fit-content" weight="bold" color="orange" fontSize={['0.3rem', '0.9rem', '1.5rem']}>
            {number}
          </CustomHeading>
          
          <CustomText 
            maxInlineSize={"100%"}
            color="orange" 
            className={numberText ? "ms-2" : "d-none"} 
            fontSize={['0.3rem', '0.8rem', '1.3rem']}>
            {numberText ?? ""}
          </CustomText>
        </div>
      ) : (
        <CustomText maxInlineSize={"100%"} inlineSize={"fit-content"} color="orange" weight="bold" fontSize={['0.2rem', '0.5rem', '1.2rem']}>
          {number}
        </CustomText>
      )}
      
      {link ? (
        <Link to state={link}>
          <Text style={{ display: "inline" }}>{text}</Text>
          <Icon icon="chevron-right" />
        </Link>
      ) : (
        <CustomText maxInlineSize={"100%"} inlineSize={"fit-content"} margin="0"  fontSize={['0.2rem', '0.5rem', '1rem']}>
          {text}
        </CustomText>
      )}
    </div>
  );
}

LabelAndNumberView.propTypes = { ctx: PropTypes.shape() }